import { gql } from "@apollo/client";

const FailedUploads = gql`
  query AllFailedUploads($uploadId: BigInt!) {
    allFailedFiles(condition: { uploadId: $uploadId }, orderBy: ID_ASC) {
      nodes {
        id
        relativePath
        filename
        problem
      }
    }
  }
`;

const hash = "c2d5baa3c8e7fc6fb520238d0fe6201471331aa41915ccb55b11c5eded8a20bc";

export { FailedUploads, hash };
